export const notEmpty = (v: string): string | undefined =>
  !v || v.length === 0 ? "必須入力項目です" : undefined;
export const maxLength =
  (length: number) =>
  (v: string): string | undefined =>
    v && v.length > length ? `${length}文字以下まで入力可能です` : undefined;

export const mustBePositiveNumber = (v: number): string | undefined =>
  !isZeroOrPositiveNumber(v) ? "0以上の整数を入力してください" : undefined;
export const mustBeInteger = (v: number): string | undefined =>
  !Number.isInteger(v) ? "小数点以下は入力できません" : undefined;

export const isZeroOrPositiveNumber = (num: number) => num >= 0;
export const isPositiveNumber = (num: number) => num > 0;
